export const NBSP = '\u00a0';
export const CR = '\u000d';
export const LF = '\u000a';
